import React from 'react';
import { Button } from 'reactstrap';
import { NavLink as NavLinkRouter } from 'react-router-dom';
import Icon from 'components/Icon';

const AdminCustomerRequired = () => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: '70vh' }}
    >
      <div className="text-center" style={{ maxWidth: 520 }}>
        <Icon
          icon="building"
          width={48}
          height={48}
          className="text-warning mb-3"
        />
        <h4 className="mb-2">Selecione um cliente para continuar</h4>
        <p className="text-muted mb-4">
          Como administrador, você precisa escolher um cliente no seletor do
          topo antes de acessar as páginas do portal do cliente.
        </p>
        <div className="d-flex gap-2 justify-content-center">
          <Button color="primary" tag={NavLinkRouter} to="/admin" replace>
            Ir para o Dashboard Admin
          </Button>
          <Button
            color="secondary"
            tag={NavLinkRouter}
            to="/admin/customers"
            replace
          >
            Ver clientes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AdminCustomerRequired;
